import { useAsync } from '@flowwai-frontend/shared/common-components'

import {
   VerifyEmailOTPAPIRequestType,
   VerifyEmailOTPAPIResponseType
} from '../../services/types'

import { useLoginService } from '../services/useLoginService'

const useVerifyEmailOTPAPI = () => {
   const loginService = useLoginService()

   const {
      mutateAsync: verifyEmailOTPAPI,
      apiStatus: verifyEmailOTPAPIStatus,
      error: verifyEmailOTPAPIError
   } = useAsync<
      VerifyEmailOTPAPIResponseType | unknown,
      Error,
      VerifyEmailOTPAPIRequestType
   >(loginService.verifyEmailOTP)

   return {
      verifyEmailOTPAPI,
      verifyEmailOTPAPIStatus,
      verifyEmailOTPAPIError
   }
}

export { useVerifyEmailOTPAPI }
